import { themeGet } from '@styled-system/theme-get';
import { Popover } from 'antd';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { SeriesAvailability } from '../SeriesAvailability';
import { ReactComponent as PlusIcon } from '../../../assets/images/PlusIcon.svg';
import { ReactComponent as StickyIcon } from '../../../assets/images/StickyNote.svg';
import { ReactComponent as GreenAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Green.svg';
import { ReactComponent as YellowAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Yellow.svg';
import { ReactComponent as RedAvailabilityIcon } from '../../../assets/images/AvailabilityIcons/Red.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/Trashcan.svg';
import { Button } from '../../../components/Button/Button';
import { IconButton } from '../../../components/IconButton/IconButton';
import { SeriesLookup } from '../../../logic/store/Seeds/SeedLookups';

export const SeriesRow = (props: {
	series: SeriesLookup[0];
	pickerContent?: React.ReactNode;
	pickerTitle?: string;
	isGoldenHarvestUser?: boolean;
	onLocalPositioning: (seriesId: string) => void;
	onDelete: (series: SeriesLookup[0]) => void;
}) => 
{
	const theme = useTheme();

	const availability = props.series.Availability;
	return (
		<StyledSeriesRow className={`SeriesContainer SeriesContainer-${props.series.SeriesId}`}>
			{!props.isGoldenHarvestUser && (<SeriesAvailability className='SeriesAvailability'>
				{availability == 'Green' ? <GreenAvailabilityIcon />
					: availability === 'Yellow' ? <YellowAvailabilityIcon />
						: <RedAvailabilityIcon />
				}
			</SeriesAvailability>)}
			<div className='SeriesName'>{props.series.SeriesName}</div>
			<div className='SeriesRm'>RM: {props.series.RelativeMaturity}</div>
			<div className='Picker'>
				<Popover
					placement='bottom'
					trigger='click'
					content={props.pickerContent}>
					{props.pickerTitle && (
						<Button 
							style={{
								width: 206,
								height: 32,
								marginLeft: 32,
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'space-between',
								alignItems: 'center'
							}} 
							variant='outlined'
						>
							<span style={{ paddingLeft: 9 }}>{props.pickerTitle}</span>
							<span 
								style={{ 
									paddingRight: 9, 
									display: 'flex', 
									flexDirection: 'row', 
									alignItems: 'center' 
								}}
							>
								<PlusIcon fill={theme.colors.darkGrey} />
							</span>
						</Button>
					)}
				</Popover>
			</div>
			<div className='Spacer' />
			<div className='SeriesAction'>
				<IconButton className='SeriesActionEditLocalPositioning' onClick={() => props.onLocalPositioning(props.series.SeriesId)}>
					<StickyIcon />
				</IconButton>
				<IconButton className='SeriesActionDelete' color={theme.colors.redLM} onClick={() => { props.onDelete(props.series); }}>
					<DeleteIcon />
				</IconButton>
			</div>
		</StyledSeriesRow>
	);
};

const StyledSeriesRow = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 50px;
	min-height: 50px;
	border: 1px solid;
	border-color: ${themeGet('colors.lightestGrey')};
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
	margin-top: 16px;
	align-items: center;

	.SeriesName { 
		color: ${themeGet('colors.darkGrey')};
		font-family: ${themeGet('fonts.base')};
		font-size: ${themeGet('fontSizes.extraSmall')};
		font-weight: ${themeGet('fontWeights.bold')};
		padding-left: 12px;
		padding-right: 12px;
		width: 88px;
	}

	.SeriesRm {
		color: ${themeGet('colors.darkGrey')};
		font-family: ${themeGet('fonts.base')};
		font-size: ${themeGet('fontSizes.extraSmall')};
		font-weight: ${themeGet('fontWeights.bold')};
		padding-left: 12px;
		padding-right: 12px;
	}

	.Spacer {
		flex-grow: 1;
	}

	.SeriesAction {
		padding-right: 12px;
		display: flex;
		flex-direction: row;
	}
`;

